const backendCardDescription: string = `Providing solutions for backend services. The services of backend gives promising stability, perfomance and 
data solutions. These services also offer data processing for AI and ML training models. The implementation with Docker to deliver and deploy services. 
With testing and test cases to automate repetitive cases and manual testing to cover the new cases to ensure quality assurance`;

const backendTechnologiesAndTools: string[] = [
  'Node',
  'Python',
  'Serverless Framework',
  'Adonis JS',
  'Django',
  'MicroServices',
  'Nestjs',
  'OpenAI',
  'Authentication',
  'Authorization',
]

export { backendCardDescription, backendTechnologiesAndTools };
